export default __webpack_public_path__ + "static/media/zampiano.b48f46c7.txt";